export enum AssistantTicketResultType {
  KnowledgeBase = 'Knowledge',
  Ticket = 'Tickets',
  Conversations = 'Conversations',
}
export const getAssistantTicketResultTitle = (type: string, name: string, title: string): string => {
  return name === 'Ticket' && type === 'salesforce' ? 'Cases' : title;
};
